/**
 * Formats a shop article price for display.
 *
 * IMPORTANT — unit convention: shop article prices (`shop_articles.price_eur`,
 * `shop_articles.price_usd`) are stored as DECIMAL **currency units** (e.g.
 * 15.99), NOT cents. Cart items carry these values verbatim. This formatter
 * must therefore NOT divide by 100 — doing so is the exact regression that
 * rendered prices 100x too low (€0.16 instead of €15.99) across the cart and
 * the organization shop tab.
 *
 * The actual Stripe charge is computed server-side (`api/shops/checkout` does
 * `unit_price * 100`), so this helper is display-only.
 */
export function formatArticlePrice(
  amount: number,
  currency: string,
  locale = 'en-US',
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
}
